import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import path from 'path';
import { isExternal } from "../../../utils/validate";
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
import uMengDataMixin from '@/mixins/uMengDataMixins';
export default {
  name: 'SidebarItem',
  components: {
    Item: Item,
    AppLink: AppLink
  },
  mixins: [FixiOSBug, uMengDataMixin()],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      itemShow: false,
      // 本菜单是否需要显示
      initPageEnd: false,
      itemShowChildren: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.initPage().finally(function () {
      _this.initPageEnd = true;
    });
  },
  computed: {
    toUrl: function toUrl() {
      if (this.item.path.indexOf('/') === 0 || this.basePath === '/') {
        return "".concat(this.basePath).concat(this.item.path);
      } else {
        return "".concat(this.basePath, "/").concat(this.item.path);
      }
    },
    // 有可展示的子菜单
    hasShowChildren: function hasShowChildren() {
      if (this.hasChildren) {
        if (this.itemShowChildren.length === 1) {
          return this.itemShowChildren[0].children;
        }
        return this.itemShowChildren.length > 1;
      }
      return false;
    },
    // 有子菜单
    hasChildren: function hasChildren() {
      return Array.isArray(this.item.children) && this.item.children.length > 0;
    },
    //
    routeItem: function routeItem() {
      if (this.hasChildren && this.itemShowChildren.length === 1) {
        var item = this.itemShowChildren[0];
        item['path'] = "".concat(this.item.path, "/").concat(item.path);
        return item;
      }
      return this.item;
    }
  },
  methods: {
    initPage: function () {
      var _initPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.hasShowChildrenFun();
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function initPage() {
        return _initPage.apply(this, arguments);
      }
      return initPage;
    }(),
    /**
     * 是否有需要展示的子菜单
     * */
    hasShowChildrenFun: function () {
      var _hasShowChildrenFun = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 有子菜单
                if (this.hasChildren) {
                  this.itemShowChildren = this.item.children.filter(function (ele) {
                    return !ele.hidden;
                  });
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function hasShowChildrenFun() {
        return _hasShowChildrenFun.apply(this, arguments);
      }
      return hasShowChildrenFun;
    }(),
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    }
  }
};